<div class="layout-inner">
  <div class="text">
    <h1 class="header">{{'app.landing.customers.title' | translate}}</h1>
    <p>{{'app.landing.customers.text' | translate}}</p>
    <button mat-flat-button color="primary" class="main-button mobile-hidden" (click)="onStartClick()">{{'app.header.start' | translate}}</button>
  </div>
  <div class="image">
    <img src="assets/img/Header_graphic.png" alt="clients">
  </div>
  <button mat-flat-button color="primary" class="main-button desktop-hidden" (click)="onStartClick()">{{'app.header.start' | translate}}</button>
</div>
